module.exports = __webpack_public_path__ + "img/news.082aef80.png";